import React from 'react';
import { Link } from 'react-router-dom';
import './OsumitsukiScorePage.css';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';

function OsumitsukiScorePage() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'サービス', path: '/service' },
    { label: 'OSUMITSUKI Score', path: '/osumitsuki-score' }
  ];

  return (
    <div>
      <SEO page="osumitsuki-score" />

      {/* ページ見出し */}
      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <div className="score-hero">
            <div className="score-hero-text">
              <p className="ds-eyebrow">SERVICE / PLATFORM</p>
              <h1 className="ds-h1">OSUMITSUKI Score</h1>
              <p className="score-hero-catch">社会で共通の人材評価プラットフォーム</p>
              <p className="ds-lead">
                OSUMITSUKI Scoreは、人材の実力を可視化し、企業と個人の成長を加速させる人材評価指標プラットフォームです。
                30項目以上の共通評価基準に基づき、候補者・社員を多角的に査定。
                評価データは採用・育成・配置・昇格などライフサイクル全体で活用可能で、従来属人的だった人材評価を客観的・定量的に変える新しい基盤です。
              </p>
            </div>
            <div className="score-hero-image">
              <img src="/images/osumitsuki_score_B.jpg" alt="OSUMITSUKI Score" />
            </div>
          </div>
        </div>
      </section>

      {/* 実績数値 */}
      <section className="score-metrics">
        <div className="container">
          <dl className="score-metrics-grid">
            <div className="score-metric">
              <dt className="score-metric-desc">契約企業数</dt>
              <dd className="score-metric-value ds-num">200社+</dd>
            </div>
            <div className="score-metric">
              <dt className="score-metric-desc">共通評価項目数</dt>
              <dd className="score-metric-value ds-num">30項目+</dd>
            </div>
            <div className="score-metric">
              <dt className="score-metric-desc">業界平均比（評価基準の信頼性）</dt>
              <dd className="score-metric-value ds-num">内定率7.5倍</dd>
            </div>
            <div className="score-metric">
              <dt className="score-metric-desc">月間評価件数（直近実績）</dt>
              <dd className="score-metric-value ds-num">30万件規模</dd>
            </div>
          </dl>
        </div>
      </section>

      {/* スコアの活用 */}
      <section className="ds-section ds-section--alt">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">USE CASES</p>
            <h2 className="ds-h2">OSUMITSUKI Scoreの活用</h2>
          </div>
          <div className="score-grid-3">
            <div className="ds-card score-card">
              <div className="score-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" fill="none" />
                  <path d="M16 24h16M24 16v16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <h3 className="ds-h3">採用</h3>
              <p className="score-text">共通一次面接で候補者を評価。2次面接確約により、選考ステップを大幅に短縮。企業ごとのバラつきがない公平な選考を実現します。</p>
            </div>
            <div className="ds-card score-card">
              <div className="score-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="8" y="20" width="8" height="18" rx="1" stroke="currentColor" strokeWidth="2" fill="none" />
                  <rect x="20" y="14" width="8" height="24" rx="1" stroke="currentColor" strokeWidth="2" fill="none" />
                  <rect x="32" y="8" width="8" height="30" rx="1" stroke="currentColor" strokeWidth="2" fill="none" />
                </svg>
              </div>
              <h3 className="ds-h3">育成</h3>
              <p className="score-text">社員のスキルを定量スコアリングし、市場価値との比較で成長課題を明確化。週次1on1プログラムで着実にスキルアップを支援します。</p>
            </div>
            <div className="ds-card score-card">
              <div className="score-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" fill="none" />
                  <path d="M24 12v12l8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="ds-h3">配置・昇格</h3>
              <p className="score-text">客観的な評価データに基づき、適材適所の人材配置を実現。定期的な査定で成長の推移をデータで追跡し、昇格判断の根拠を提供します。</p>
            </div>
          </div>
        </div>
      </section>

      {/* 評価の仕方 */}
      <section className="ds-section">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">METHOD</p>
            <h2 className="ds-h2">OSUMITSUKI Scoreの評価方法</h2>
            <p className="ds-lead">
              共通の評価基準と独自の評価プロセスにより、信頼性の高い人材評価を実現します。
            </p>
          </div>
          <ol className="score-grid-3 score-steps">
            <li className="ds-card score-card">
              <div className="score-step-head">
                <span className="score-step-num ds-num">STEP 01</span>
                <div className="score-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="14" r="8" stroke="currentColor" strokeWidth="2" fill="none" />
                    <path d="M12 38c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
                    <path d="M32 20l4-4m0 0l4 4m-4-4v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
              <h3 className="ds-h3">面接形式で確認</h3>
              <p className="score-text">30項目以上の共通評価基準に基づき、キャリアアセッサー（実務経験豊富な面接官）が面接形式で候補者のスキル・経験・志向性を多角的に確認します。</p>
              <div className="score-tags">
                <span className="ds-tag">共通の評価基準</span>
                <span className="ds-tag">キャリアアセッサー（面接官）</span>
              </div>
            </li>
            <li className="ds-card score-card">
              <div className="score-step-head">
                <span className="score-step-num ds-num">STEP 02</span>
                <div className="score-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6" y="6" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
                    <rect x="26" y="6" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
                    <path d="M10 30h28M10 36h20M10 42h24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="14" cy="14" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
                    <path d="M31 10l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
              <h3 className="ds-h3">AIと人による評価</h3>
              <p className="score-text">面接で得られた情報をもとに、AIによるデータ分析と人による定性評価を組み合わせてスコアリング。強みだけでなく懸念点まで含めた中立的な評価を実現します。</p>
              <div className="score-tags">
                <span className="ds-tag">AI分析</span>
                <span className="ds-tag">人による定性評価</span>
              </div>
            </li>
            <li className="ds-card score-card">
              <div className="score-step-head">
                <span className="score-step-num ds-num">STEP 03</span>
                <div className="score-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="2" fill="none" />
                    <path d="M24 6c9.941 0 18 8.059 18 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                    <path d="M15 24l6 6 12-12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
              <h3 className="ds-h3">市場評価として確立</h3>
              <p className="score-text">共通の評価軸で査定されたスコアは、業界・職種を横断して比較可能な市場評価として確立。採用・育成・配置・昇格など人材ライフサイクル全体で活用できます。</p>
              <div className="score-tags">
                <span className="ds-tag">共通評価軸</span>
                <span className="ds-tag">市場価値の可視化</span>
              </div>
            </li>
          </ol>

          <div className="score-diagram">
            <img src="/images/osumitsuki_score2.jpg" alt="OSUMITSUKI Score 評価の流れ" />
          </div>
        </div>
      </section>

      {/* 3つのサービス */}
      <section className="ds-section ds-section--alt">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">SERVICES</p>
            <h2 className="ds-h2">OSUMITSUKI Scoreを基盤とした3つのサービス</h2>
          </div>
          <div className="score-grid-3">
            <div className="ds-card score-card score-service score-service--recruit">
              <div className="score-service-logo">
                <img src="/images/rogo_recruit.png" alt="転職のセンター試験" />
              </div>
              <p className="score-service-subtitle">転職・採用サービス</p>
              <h3 className="ds-h3">転職のセンター試験</h3>
              <p className="score-text">1度の共通一次面接で複数企業の1次面接合格判定。合格者には2次面接確約のオファーが届く、センター試験型の転職プラットフォームです。</p>
              <div className="score-service-links">
                <a href="https://lp.p-osumitsuki.com/" target="_blank" rel="noopener noreferrer" className="ds-link">
                  転職をお考えの方
                </a>
                <a href="https://osumitsuki-b.studio.site/" target="_blank" rel="noopener noreferrer" className="ds-link">
                  採用をお考えの方
                </a>
              </div>
            </div>

            <div className="ds-card score-card score-service score-service--skill">
              <div className="score-service-logo">
                <img src="/images/rogo_skill.png" alt="スキルの通知表" />
              </div>
              <p className="score-service-subtitle">スキルの可視化サービス</p>
              <h3 className="ds-h3">スキルの通知表</h3>
              <p className="score-text">社員一人ひとりのスキルを30分の面談で可視化・スコアリング。市場価値と社内評価のギャップを客観的に把握し、成長の推移をデータで追跡します。</p>
              <div className="score-service-links">
                <Link to="/contact" className="ds-link">
                  お問い合わせ
                </Link>
              </div>
            </div>

            <div className="ds-card score-card score-service score-service--expansion">
              <div className="score-service-logo">
                <img src="/images/rogo_expansion.png" alt="スキルの拡張パック" />
              </div>
              <p className="score-service-subtitle">社員育成サービス</p>
              <h3 className="ds-h3">スキルの拡張パック</h3>
              <p className="score-text">TWI（Training Within Industry）をベースにした週次60分の1on1育成プログラム。PDAの3層モデルにより個人の課題を構造的に分析し、フルオーダーメイドの教育を提供します。</p>
              <div className="score-service-links">
                <a href="https://pack.p-osumitsuki.com/" target="_blank" rel="noopener noreferrer" className="ds-link">
                  詳しく見る
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="ds-section">
        <div className="container">
          <div className="ds-section-head ds-section-head--row score-cta">
            <div>
              <p className="ds-eyebrow">CONTACT</p>
              <h2 className="ds-h2">OSUMITSUKI Scoreで人材評価を変革しませんか？</h2>
              <p className="ds-lead">サービスの詳細を知りたい、デモを依頼したい方はお気軽にお問い合わせください。</p>
            </div>
            <Link to="/contact" className="ds-btn ds-btn--primary ds-btn--arrow">
              お問い合わせ
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default OsumitsukiScorePage;
